<ds-truncatable [id]="mdRepresentation.id">
  <a [routerLink]="[itemPageRoute]"><img src="assets/dspace/images/favicons/favicon.png" height="30px" alt=""> {{ mdRepresentation.getValue()}}</a>
</ds-truncatable>
